import { Injectable, Component, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable ,  BehaviorSubject } from 'rxjs';
import { AuthTokenModel, LoginModel } from './models';
import { ConfigService } from '../shared/utils/config.service';


@Injectable()
export class LoginService {
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json'
  });
  baseUrl: string = '';

  private loggedIn = false;

  constructor(private http: HttpClient, private configService: ConfigService,
    @Inject('BASE_URL') baseUrl: string) {
    
    this.baseUrl = baseUrl;

    configService.setBaseUrl(baseUrl);
  }

  login(model: LoginModel):Observable<AuthTokenModel> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
   
    return this.http
      .post<AuthTokenModel>(this.baseUrl + 'api/authentication/signin',
        {
          "Username": model.username,
          "Password": model.password,
          "Email": model.email,
          "Session": model.session,
          "Challenge": model.challenge,
          "ChallengeParams": model.challengeParams
        });      
  }

  GetSSOUrl(): Observable<string> {
    return this.http.get<string>(this.baseUrl + 'api/authentication/getSsoUrl', { headers: this.headers });
  }

  ssoLogin(code: string): Observable<AuthTokenModel> {

    const params = new HttpParams().set("auth_code", code); //Create new HttpParams

    return this.http.post<AuthTokenModel>(this.baseUrl + 'api/authentication/ssoSignin',
      { "auth_code": code });
   
  }

  logout(): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'api/authentication/logout', {});
  }
}
